import * as React from 'react';
import { CircularProgress, Divider, ListItemButton, ListItemText, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

interface DownloadOptionsListProps {
  failed: boolean;
  listTitle: string;
  listOptions: (string | null)[];
  onSelectOption: (option: string) => Promise<void> | void;
  selectedOption: string | null;
  setSelectedOption: (option: string) => void;
}

const DivContainer = styled('div')({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
});

const DividerStyled = styled(Divider)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  width: '100%',
}));

const ListItemButtonStyled = styled(ListItemButton)(({ theme }) => ({
  padding: `${theme.spacing(1)}px ${theme.spacing(3)}px`,
  position: 'relative',
  textTransform: 'uppercase',
}));

const ListItemTextStyled = styled(ListItemText)({
  '& .MuiListItemText-primary': {
    fontSize: '0.9rem',
  },
});

const CircularProgressStyled = styled(CircularProgress)({
  left: '-6px',
  position: 'absolute',
});

const DownloadOptionsList: React.FC<DownloadOptionsListProps> = ({
  failed,
  listTitle,
  listOptions,
  onSelectOption,
  selectedOption,
  setSelectedOption,
}) => {
  const handleDownload = (option: string) => {
    setSelectedOption(option);
    onSelectOption(option);
  };

  return (
    <DivContainer>
      <Typography variant="h6" component="h2">
        {listTitle}
      </Typography>
      <DividerStyled />
      {listOptions.map((option) => (
        <ListItemButtonStyled
          key={option}
          disabled={failed}
          onClick={() => handleDownload(option || '')}
          data-cy={`download-option-${listTitle}-${option}`}
        >
          {failed && option === selectedOption && <CircularProgressStyled size={20} />}
          <ListItemTextStyled primary={option} />
        </ListItemButtonStyled>
      ))}
    </DivContainer>
  );
};

export default DownloadOptionsList;
